import { AddCustomerPayload } from "@/models/payload/customer";
import customerService from "@/services/customer";
import { notifications } from "@mantine/notifications";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

type Props = {
  doNavigate?: boolean;
  close?: (customerId: number) => void;
  route?: string;
};

function useAddCustomer({ doNavigate = true, close, route }: Props) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const {
    mutate: addCustomer,
    isLoading,
    isSuccess,
  } = useMutation({
    mutationFn: (command: AddCustomerPayload) => {
      return customerService.addCustomer(command);
    },
    onSuccess: (data) => {
      if (close) {
        close(data?.customerId || 0);
        queryClient.invalidateQueries({ queryKey: ["customers"] });
      } else {
        notifications.show({
          title: "عملیات موفق",
          message: "مشتری با موفقیت اضافه شد",
          color: "green",
        });
        if (doNavigate)
          queryClient
            .invalidateQueries({ queryKey: ["customers"] })
            .then(() => {
              navigate(route ?? "/dashboard/customers");
            });
      }
    },
  });
  return { addCustomer, isLoading, isSuccess };
}

export default useAddCustomer;
